
import React, { useContext, useEffect,useState} from 'react';
import Axios from 'axios';
import { useHistory } from "react-router-dom"; 
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, CardMedia, CircularProgress, Typography, Dialog,
  DialogTitle, } from '@material-ui/core';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import { Store } from '../Store';
import axios from "axios";
import SignUp from './SignUp';
import BillSummary from '../components/Bill_Summary';
import { useIntl } from "react-intl";
//import { closeQrCode,setOrderType,getCheckoutUrl } from '../actions';
//import QRCode from "react-qr-code";
import {
  clearOrder,

} from '../actions';
import { setPaymentType, fetchCheckoutFormFromPayU, createOrder,paymentReq , getCheckoutUrl,updateOrder, setCustomerId } from '../actions';
import config,{ getParameterByName,merchantCode} from '../util';


export default function PaymentScreen(props) {
  
 //const baseURL = config.baseURL
 // const payURL = "https://pay.digitallive24.com";
  const { state, dispatch } = useContext(Store);
  const { selectedCurrency, order, fetchQr,newURL } = state;
    const { formatMessage: t, locale, setLocale } = useIntl();
  let paytimer = null;
  ///console.log(newQr);
  const styles = useStyles();
  const history = useHistory();
  //console.log(fetchQr);
  //console.log(newQr);
  const { loading, error, newOrder } = state.orderCreate;
  const [openForm,setOpenForm] = useState(false);
  const [openSign,setOpenSign] = useState(false);
  const [isPickUp,setIsPickUp] = useState(false);
  const [isDeliver,setIsDeliver] =useState(false);
  const [payStatusPaid,setPayStatusPaid] = useState(false);
  const [userName,setUserName] = useState("");
  const [number,setNumber] =useState("");
  const [schedule,setSchedule]= useState("");
  const [address,setAddress] =useState("");
let { setting } = state.userSetting;
  const customerInfo =sessionStorage.getItem("customerInfo")?JSON.parse(sessionStorage.getItem("customerInfo")):null;
  console.log(customerInfo);

  let isPaymentAllowed = setting ? setting.isPaymentAllowed : "";
   let userData =localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):null;
  const email = userData ? userData.email : "";
  const upiId = userData ? userData.paymentProviderCode : "";
  const upiName = userData ? userData.firstName : "";
  const gst = userData ? userData.taxCodeNo : "";
  let invoiceData= null;
  let loggedUser =sessionStorage.getItem("customerInfo")?JSON.parse(sessionStorage.getItem("customerInfo")):null;
  let orderDetails = newOrder;
  useEffect(() => {
    if(newURL?.data?.id && userData.selectedPayGateway == "STRIPE"){
      window.stripe.redirectToCheckout({sessionId:newURL.data.id })
    }
 },[newURL]);
  useEffect(()=>{
  if(loggedUser&&loggedUser.customer){
   setCustomerId(dispatch,loggedUser.customer.id);
  // selectHandler("Pick Up");
  }else{
    console.log('opning login');
    setOpenSign(true);
  }
},[])
  useEffect(() => {
    let billData = {};
    billData.userId = merchantCode;
    billData.appName = "Online Order";
    billData.payType = "onetime";
    billData.payStatus = "Pending";
    billData.purchaseItems =
      order && order.orderItems ? order.orderItems : "";

    axios.post(`${config.payUrl}/api/new-order`, billData).then((invData) => {
      //setInvoiceNo(invData.data.invoiceData.invoicePath);
      invoiceData=invData.data.invoiceData;
      let invoicePath=invData.data.invoiceData.invoicePath;
      if (order && order.orderItems.length) {
        createNewOrder(invoicePath, invData.data.invoiceData._id);
    }
    });
    
  }, []);


 const createNewOrder = (invoicePath, invoiceId) => {
      let items = order.orderItems.map((o) => {
        o["status"] = "inProgress";
        o["sub_pro"] = JSON.stringify(o.sub_pro);
        return o;
      });
      order.orderItems = items;
      order.paymentType = order.paymentType || "";
      order.customerId = customerInfo?.customer?.id;
      order.userId = merchantCode;
      order.mac = customerInfo?.customer?.id;
      order.invoiceId= invoicePath;

            
      createOrder(dispatch, order);
      console.log("order created");
      localStorage.removeItem('splashShown');
   // }
  };

  const payOnlineViaGateway = () => {
    let paymentObj = getPaymentObj(newOrder.invoicePath, invoiceData._id, order.totalPrice);
     if(paymentObj.surl){
    paymentObj.surl= paymentObj.surl+newOrder.id;
    }
    else if(paymentObj.success_url){
      paymentObj.success_url= paymentObj.success_url+newOrder.id;
    }
    if(userData.selectedPayGateway == 'PAYU'){
    paymentReq(paymentObj);
    }else if(userData.selectedPayGateway == 'STRIPE'){
        getCheckoutUrl(dispatch, paymentObj);
    }
  }

  const getPaymentObj= (invoicePath,invoiceId, amountTotal)=>{
    //payment obj
      const getCurrency = userData? userData.currency:"INR";
    const getPercent = userData? userData.taxPerc:0;
     if(userData.selectedPayGateway == "STRIPE"){
       let items = [];
        if (order) {
          order.orderItems.map((o) => {
            items.push({
              price_data: {
                currency: getCurrency,
                product_data: {
                  name: o.name
                },
                unit_amount: parseInt(o.price * 100 + (o.price * getPercent / 100) * 100)
              },
              quantity: o.quantity
            })
          });
        }
      return {
          purchaseItems: items,
          success_url: window.location.origin + '/complete?' + window.location.href.split('?')[1]+'&invoice='+invoicePath+'&ord_id=',
          cancel_url: window.location.origin + '/?' + window.location.href.split('?')[1],
          userId:  customerInfo?.customer?.id,
          appName: "online",
          payType: "onetime",
          payStatus: "unpaid",
          _id: invoiceId
        }
     }else if(userData.selectedPayGateway == "PAYU")
     {
       let products =order.orderItems.reduce((accum="",cur)=> {
        return accum += cur.name +", ";
      }, "");
      // let amountTotal = order.orderItems.reduce((accum=0,cur)=> {
      //   return accum +=   parseInt(cur.price  + (cur.price * getPercent / 100)) * cur.quantity;
      // }, 0);
      let trxnId = Math.random().toString(5).slice(2);

      let paymentObj ={
          items: products,
          amount: amountTotal,
          txnid:'PUOL_'+invoicePath+'_'+trxnId,
          surl: window.location.origin + '/complete?' + window.location.href.split('?')[1]+"&ord_id=",
          furl: window.location.origin + '/?' + window.location.href.split('?')[1],
          fname: customerInfo.customer.firstName,
          lname: customerInfo.customer.lastName,
          email: customerInfo.customer.email,
          phone: customerInfo.customer.phone
        }

        return paymentObj;
      }
  }

   const orderStauts = () => {
    let id = orderDetails._id;
    axios.get(`${config.baseURL}/api/orders/${id}`).then((res) => {
      if (res.data.isPaid) {
        setPayStatusPaid(true);
      }
    });
  };

    const startPayCheckTimer = () => {
      orderStauts();
      if(paytimer) clearTimeout(paytimer);
   let paytimer =  setTimeout(() => {
      if(payStatusPaid){
        gotoTrackingOrder();
       }else{
        startPayCheckTimer();
       }
    }, 1000*10);
    }

    const updateOrderPart= (updateOrdData, ordId) => {
      updateOrder(dispatch, updateOrdData, ordId);
    }

    const gotoTrackingOrder = () => {
      props.history.push('/complete?' + window.location.href.split('?')[1]+"&ord_id="+newOrder.id);
  };


  let paymentUrl = orderDetails
    ? `upi://pay?pn=${upiName}&pa=${upiId}&am=${orderDetails.totalPrice}&tn=${orderDetails.invoicePath}`
    : "";
  return (
    <>
      <Box className={[styles.root, styles.navy]} style={{ backgroundColor: userData.themeColor,overflow:"hidden", overflowY:"auto" }}>
       {openSign && !loggedUser && <Dialog open={true} fullWidth maxWidth="sm">
      <SignUp log={true} setOpenSign={setOpenSign} 
      procedToCheckoutHandler={()=> window.location.reload()}/>
      </Dialog>}
       <Box className={[styles.center, styles.around]} style={{backgroundColor: userData.themeColor,width:"100%"}}>
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 1 }}>
        <ArrowBackIosNewIcon 
          style={{color: userData.themeTxtColor}} 
          onClick={() => history.goBack()}
        />
        <Typography variant="h4" style={{ color:userData.themeTxtColor, fontFamily: userData.themeSecondaryFontFam }}>
           Review & Pay
        </Typography>
        <Box style={{width: "24px"}} />
      </Box>
      </Box>
        {orderDetails && <BillSummary userData={userData} totalPrice={orderDetails.totalPrice} 
              taxPrice={orderDetails.taxPrice} 
              t={t} orderType={orderDetails.orderType||"eat in"}
              />}
          
          {orderDetails && (
            <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    gap: "10px",
    padding: "30px",
    flexWrap: "wrap", // keep if you want wrapping on very small screens
  }}
>

          {userData.OO_isOfflineQR_Pay && <Button className="pay-btn"
                     style={{
  width: "250px",
  height: "150px",
  backgroundColor: userData.themeTxtColor,
  color: userData.themeColor,
  fontSize: "1.2em!important",
}}><a
  href={paymentUrl}
  target="_blank"
  style={{
    fontSize: "18px",
    fontWeight: "bold",
    textDecoration: "none",
    color: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  }}
>
  Pay via App (UPI/Scanner)
</a></Button>}
          {userData.OO_isCoD_Pay && <button
                      className="pay-btn"
                     style={{
  width: "250px",
  height: "150px",
  backgroundColor: userData.themeTxtColor,
  color: userData.themeColor,
  fontSize: "1.2em!important",
}}
                      onClick={()=> (updateOrderPart({paymentType:"At Counter"}, newOrder.id),gotoTrackingOrder())}
                    >
                      {t({ id: "pay_at_counter" })}
                    </button>}
              {userData.OO_isGateway_pay && <button
                      className="pay-btn"
                     style={{
  width: "250px",
  height: "150px",
  backgroundColor: userData.themeTxtColor,
  color: userData.themeColor,
  fontSize: "1.2em!important",
}}
                      onClick={()=>(updateOrderPart({paymentType:"Gateway"}, newOrder.id),payOnlineViaGateway())}
                    >
                      {t({ id: "gateway_pay" })}<br/><span style={{fontSize:"0.6em"}}>{'(NetBanking, Credit Card Or Debit Card, gateway UPI)'}</span>
                    </button>}
          </div>
          )}
      </Box>
    </>
  );
}